import { motion } from "framer-motion";

export default function MarqueeStrip() {
  const words = [
    "UI / UX Design",
    "Graphic Design",
    "Logo Design",
    "Brand & Identity",
    "Illustration",
    "Typography",
    "Editorial Design",
    "Book Covers",
  ];

  return (
    <section
      className="relative py-10 border-y border-[var(--ink)] bg-[var(--bg)] overflow-hidden"
      data-testid="marquee-strip"
    >
      <div className="marquee-track items-center gap-12 whitespace-nowrap">
        {[...words, ...words, ...words].map((w, i) => (
          <div key={i} className="flex items-center gap-12">
            <span
              className={`font-display italic text-5xl md:text-7xl ${
                i % 2 === 0 ? "text-[var(--ink)]" : "outline-text"
              }`}
            >
              {w}
            </span>
            <span className="font-display text-5xl md:text-7xl text-[var(--klein)]">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
